document.addEventListener('DOMContentLoaded', function () {
	function syncVariantThumbnailRadioState(scope) {
		(scope || document).querySelectorAll('.product-section__variant-thumbnails').forEach((group) => {
			group.setAttribute('role', 'radiogroup');

			var thumbnails = Array.from(group.querySelectorAll('.product-section__variant-thumbnail'));
			var visibleThumbnails = thumbnails.filter((thumbnail) => {
				return !thumbnail.classList.contains('hide-color') &&
					!thumbnail.classList.contains('custom-hide-color') &&
					thumbnail.getClientRects().length > 0;
			});
			var setSize = visibleThumbnails.length;

			thumbnails.forEach((thumbnail) => {
				var visibleIndex = visibleThumbnails.indexOf(thumbnail);
				var isVisible = visibleIndex !== -1;

				thumbnail.setAttribute('role', 'radio');
				thumbnail.removeAttribute('aria-pressed');
				thumbnail.setAttribute('tabindex', isVisible ? '0' : '-1');
				thumbnail.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
				thumbnail.setAttribute('aria-checked', thumbnail.classList.contains('is-active') ? 'true' : 'false');

				if (isVisible) {
					thumbnail.setAttribute('aria-posinset', String(visibleIndex + 1));
					thumbnail.setAttribute('aria-setsize', String(setSize));
				} else {
					thumbnail.removeAttribute('aria-posinset');
					thumbnail.removeAttribute('aria-setsize');
				}
			});
		});
	}
	window.syncVariantThumbnailRadioState = syncVariantThumbnailRadioState;

	document.querySelectorAll('.product-section__variant-thumbnail[role="radio"]').forEach((thumbnail) => {
		thumbnail.addEventListener('keydown', (event) => {
			if (event.key !== 'Enter' && event.key !== ' ') return;
			event.preventDefault();
			thumbnail.click();
		});
	});

	document.addEventListener('click', (event) => {
		if (!event.target.closest('.product-section__variant-thumbnail[role="radio"]')) return;
		setTimeout(() => syncVariantThumbnailRadioState(), 0);
		setTimeout(() => syncVariantThumbnailRadioState(), 50);
	});

	syncVariantThumbnailRadioState();

	const zoomImages = document.querySelectorAll('.product-media-modal__content .modal-image-wrapper');
	zoomImages.forEach((parent) => {
		const image = parent.querySelector('img');
		const mediaTitle = image.getAttribute('alt').split(' || ')[0];

		const variantTitle = document
			.querySelector('.product-section__variant-thumbnail.is-active')
			.getAttribute('data-variant-title');
		let variantLensTitle;
		if (document.querySelector('.product-section__variant-thumbnail.lens.is-active')) {
			variantLensTitle = document
				.querySelector('.product-section__variant-thumbnail.lens.is-active')
				.getAttribute('data-variant-option');
		}

		if (mediaTitle === variantTitle) {
			parent.style.display = 'block';
		} else {
			parent.style.display = 'none';
		}
	});

	document.querySelectorAll('li.product__media-item.grid__item.slider__slide').forEach((media, index) => {
		const mediaTitle = media.getAttribute('data-variant-media-alt').split(' || ')[0];
		const variantTitle = document
			.querySelector('.product-section__variant-thumbnail.is-active')
			.getAttribute('data-variant-title');
		let variantLensTitle;
		if (document.querySelector('.product-section__variant-thumbnail.lens.is-active')) {
			variantLensTitle = document
				.querySelector('.product-section__variant-thumbnail.lens.is-active')
				.getAttribute('data-variant-option');
		}

		if (mediaTitle === 'E-GIFT CARD') return;

		if (mediaTitle && mediaTitle === variantTitle) {
			media.style.display = 'block';
		} else {
			media.style.display = 'none';
		}
	});

  const customeShippingSection = document.querySelector('.custom_shipping_details');
  if (customeShippingSection.dataset.country !== 'united_states') {
    if (customeShippingSection.querySelector('.data.mobile'))
      customeShippingSection.querySelector('.data.mobile')?.classList.add('hidden');
    if (customeShippingSection.querySelector('.data_international.mobile'))
      customeShippingSection.querySelector('.data_international.mobile').classList.remove('hidden');
    if (customeShippingSection.querySelector('.data.desktop'))
      customeShippingSection.querySelector('.data.desktop').classList.add('hidden');
    if (customeShippingSection.querySelector('.data_international.desktop'))
      customeShippingSection.querySelector('.data_international.desktop').classList.remove('hidden');
  }

  let hasRxLink = false;
  var rxLink = ' ';
  const customShippingDetails = document.querySelector('.custom_shipping_details');

  document.querySelectorAll('.product-section__variant-thumbnail.is-active').forEach(function (thumbnail) {
    var filterAlt = thumbnail.dataset.filter;
    const hasPrescriptionBtn =
      typeof thumbnail?.dataset?.prescriptionBtn === 'string' && thumbnail?.dataset?.prescriptionBtn.trim() !== '';

    if (hasPrescriptionBtn) {
      rxLink = thumbnail?.dataset?.prescriptionBtn;
    }

    var rxImage = thumbnail?.dataset?.rxImage;

    const rxImageTag = document.querySelector('.link-to-rx .rx-image');
    const linkToRx = document.querySelector('.link-to-rx');

    if (rxLink) hasRxLink = hasPrescriptionBtn;
    if (customShippingDetails && rxLink) customShippingDetails.style.borderTop = '1px solid #DFDFDF';
    if (!hasRxLink) document.querySelector('.prescription-links').style.display = 'none';

    document
      .querySelectorAll('.product-section__media-single[data-filter="' + filterAlt + '"]')
      .forEach((el) => (el.style.display = 'block'));

    if (rxImageTag && rxImage) rxImageTag.src = rxImage;
    if (linkToRx) {
      linkToRx.classList.toggle('link-to-rx_visible', !!hasRxLink);
      if (rxLink) {
      }
      linkToRx.setAttribute('href', rxLink || '');
    }
  });

  const changeRXBox = document.querySelectorAll(
    '.product-section__variant-thumbnails:not(.original-color) .product-section__variant-thumbnail',
  );

  changeRXBox.forEach((el) => {
    el.addEventListener('click', function () {
      const linkToRx = document.querySelector('.link-to-rx');
      const hasPrescriptionBtn =
        typeof this.dataset.prescriptionBtn === 'string' && this.dataset.prescriptionBtn.trim() !== '';

      if (hasPrescriptionBtn) {
        document.querySelector('.prescription-links').style.display = 'block';
        linkToRx.classList.add('link-to-rx_visible', !!rxLink);
        // linkToRx.setAttribute('href', rxLink || '');
      } else {
        linkToRx.classList.remove('link-to-rx_visible', !!rxLink);
        document.querySelector('.prescription-links').style.display = 'none';
      }
    });
  });
	function pdpPriceInsert(element) {
		if (!element) return;

		const sizes = document.querySelectorAll('.no-color-wrapper .no-color');
		if (sizes.length > 0) return;

		const priceBox = document.querySelector('.product__main-info-wrapper .price.price--large');
		if (!priceBox) return;

		const compare = element.dataset.compare || null;
		const variantPrice = element.dataset.pdpVariantPrice;
		const compareVariantPrice = element.dataset.variantCompare;

		const regularPrice = priceBox.querySelector('.price__regular .price-item');
		const comparePriceBox = priceBox.querySelector('s.price-item.price-item--regular');
		const salePrice = priceBox.querySelector('.price__sale .price-item--last, .price__sale .price-item--sale');

		if (!variantPrice) return;

		if (!compare) {
			priceBox.classList.remove('price--on-sale');

			if (regularPrice) regularPrice.textContent = variantPrice;
			if (salePrice) salePrice.textContent = variantPrice;
			if (comparePriceBox) comparePriceBox.textContent = variantPrice;
		} else {
			priceBox.classList.add('price--on-sale');

			if (comparePriceBox) comparePriceBox.textContent = compareVariantPrice;
			if (salePrice) salePrice.textContent = variantPrice;
		}
	}
  const originalOptions = document.querySelectorAll('.original-color .product-section__variant-thumbnail');
  originalOptions.forEach(function (thumbnail) {
    thumbnail.addEventListener('click', function () {
      const mediaGallery = document.querySelector('.product__media-list.contains-media');
      if (mediaGallery) {
        mediaGallery.style.minHeight = mediaGallery.scrollHeight + 'px';
      }

      if (thumbnail.classList.contains('is-active')) return;

      if (this.parentNode.classList.contains('original-color')) {
        const selectedSeasonalColor = document.querySelector('#selected-seasonal-color');
        if (selectedSeasonalColor) selectedSeasonalColor.textContent = '';
      }
      document
        .querySelectorAll('.product-section__variant-thumbnails.original-color .product-section__variant-thumbnail')
        .forEach((el) => {
          if (el) el.classList.remove('is-active');
        });

      document
        .querySelectorAll('.product-section__variant-thumbnails.seasonal-color .product-section__variant-thumbnail')
        .forEach((el) => el.classList.remove('is-active'));

      this.classList.add('is-active');

      const filterAlt = this.dataset.filter;
      const filterId = this.dataset.variantId;
      const rxLink = this.dataset.prescriptionBtn;
      const rxImage = this.dataset.rxImage;
      const rxImageTag = document.querySelector('.link-to-rx .rx-image');
      const linkToRx = document.querySelector('.prescription-links .link-to-rx');

      document.querySelectorAll('.product-section__media-single').forEach((el) => (el.style.display = 'none'));
      document
        .querySelectorAll('.product-section__media-single[data-filter="' + filterAlt + '"]')
        .forEach((el) => (el.style.display = 'block'));

      document.querySelectorAll('.product_suspendisse').forEach((el) => (el.style.display = 'none'));
      document.querySelectorAll('.product_suspendisse_' + filterId).forEach((el) => (el.style.display = 'block'));

      const hasPrescriptionBtn =
        typeof this.dataset.prescriptionBtn === 'string' && this.dataset.prescriptionBtn.trim() !== '';

      if (hasPrescriptionBtn) {
        document.querySelector('.prescription-links').style.display = 'block';
        linkToRx.classList.add('link-to-rx_visible', !!rxLink);
        linkToRx.setAttribute('href', rxLink || '');

      } else {
        linkToRx.classList.remove('link-to-rx_visible', !!rxLink);
        document.querySelector('.prescription-links').style.display = 'none';
      }

      if (rxImageTag) rxImageTag.src = rxImage;

      if (window.innerWidth < 768 && document.querySelector('.product-section__desktop-media')) {
        document.querySelector('.product-section__desktop-media').scrollTo(0, 0);
      }

      if (mediaGallery) {
        setTimeout(() => {
          mediaGallery.style.minHeight = '';
        }, 0);
      }

      updateSelectedColor(this);
    });
  });

  const anotherColors = document.querySelectorAll(
    '.product-section__variant-thumbnails:not(.original-color) .product-section__variant-thumbnail',
  );

  anotherColors.forEach((color) => {
    color.addEventListener('click', function () {
      const linkToRx = document.querySelector('.prescription-links .link-to-rx');
      const rxLink = this.dataset.prescriptionBtn;

      const rxImage = color.dataset.rxImage;
      const rxImageTag = document.querySelector('.link-to-rx .rx-image');

      if (rxImage && rxImageTag) {
        rxImageTag.setAttribute('src', rxImage);
      }

        if (linkToRx) {
          linkToRx.setAttribute('href', rxLink);
        }
    });
  });

	document
		.querySelectorAll('.product-section__variant-thumbnails.lens-color .product-section__variant-thumbnail')
		.forEach(function (thumbnail) {
			thumbnail.addEventListener('click', function () {
				if (thumbnail.classList.contains('is-active')) return;
				document
					.querySelectorAll('.product-section__variant-thumbnails.lens-color .product-section__variant-thumbnail')
					.forEach((el) => {
						if (el) el.classList.remove('is-active');
					});
				this.classList.add('is-active');

				updateSelectedLensColor(this);
			});
		});

	document
		.querySelectorAll('.product-section__variant-thumbnails.seasonal-color .product-section__variant-thumbnail')
		.forEach(function (thumbnail) {
			thumbnail.addEventListener('click', function () {
				document
					.querySelectorAll('.product-section__variant-thumbnails.seasonal-color .product-section__variant-thumbnail')
					.forEach((el) => el.classList.remove('is-active'));
				this.classList.add('is-active');

				document
					.querySelectorAll('.product-section__variant-thumbnails.original-color .product-section__variant-thumbnail')
					.forEach((el) => el.classList.remove('is-active'));

				updateSelectedSeasonalColor(this);

				const variantId = this.dataset.variantId;
				const variantAvailable = this.dataset.variantAvailable;

				updateVariantInURL(variantId);
				changeActiveVariant(variantAvailable);
				pdpPriceInsert(this);

				function changeActiveVariant(variant) {
					const bool = variant === 'true';
					if (bool) {
						document.querySelector('.product .custom_button.sold_out')?.classList.add('hide');
						document.querySelector('.product .custom_button.add_to_cart')?.classList.remove('hide');
					} else {
						document.querySelector('.product .custom_button.sold_out')?.classList.remove('hide');
						document.querySelector('.product .custom_button.add_to_cart')?.classList.add('hide');
					}
				}

				function updateVariantInURL(variantId) {
					const url = new URL(window.location.href);
					url.searchParams.set('variant', variantId);
					window.history.replaceState({}, '', url);

					const nameId = document.querySelector('.product__info-wrapper [name="id"]');
					const flyId = document.querySelector('.fly-add-to-cart [name="id"]');

					nameId.value = +variantId;
					flyId.value = +variantId;
				}
			});
		});

	const sizes = document.querySelectorAll('.no-color-wrapper .no-color');

	document
		.querySelectorAll('.product-section__variant-thumbnails.original-color .product-section__variant-thumbnail')
		.forEach((element) => {
			element.addEventListener('click', function () {
				const variantId = this.dataset.variantId;
				const variantAvailable = this.dataset.variantAvailable;

				updateVariantInURL(variantId);
				updateSelectedColor(this);
				changeActiveVariant(variantAvailable);
				pdpPriceInsert(element);
				function changeActiveVariant(variant) {
					const str = variant; // or "false"
					const bool = variant === 'true';

					if (bool) {
						document.querySelector('.product .custom_button.sold_out')?.classList.add('hide');
						document.querySelector('.product .custom_button.add_to_cart')?.classList.remove('hide');
					} else {
						document.querySelector('.product .custom_button.sold_out')?.classList.remove('hide');
						document.querySelector('.product .custom_button.add_to_cart')?.classList.add('hide');
					}
				}

				function updateVariantInURL(variantId) {
					const url = new URL(window.location.href);
					url.searchParams.set('variant', variantId);
					window.history.replaceState({}, '', url);

					const nameId = document.querySelector('.product__info-wrapper [name="id"]');
					const flyId = document.querySelector('.fly-add-to-cart [name="id"]');
					nameId.value = +variantId;
					flyId.value = +variantId;
				}
			});
		});

	document
		.querySelectorAll('.product-section__variant-thumbnails.lens-color .product-section__variant-thumbnail')
		.forEach((element) => {
			element.addEventListener('click', function () {
				if (element.classList.contains('is-active')) return;

				updateSelectedLensColor(this);
			});
		});

	document
		.querySelectorAll('.product-section__variant-thumbnails.seasonal-color .product-section__variant-thumbnail')
		.forEach((element) => {
			element.addEventListener('click', function () {
				updateSelectedSeasonalColor(this);
			});
		});

	function updateSelectedColor(element) {
		document.querySelector('.variation-name #selected-color').textContent = element.getAttribute('data-variant-option');
		updatePDP(element);
	}

	function updateSelectedLensColor(element) {
		document.querySelector('.variation-name #selected-lens-color').textContent =
			element.getAttribute('data-variant-option');

		document.querySelectorAll('.original-color .product-section__variant-thumbnail').forEach((original) => {
			if (original.getAttribute('data-filter').includes(element.getAttribute('data-filter'))) {
				original.classList.remove('hide-color');
			} else {
				original.classList.add('hide-color');
			}
		});

		updatePDP(element);
	}

	function updateSelectedSeasonalColor(element) {
		if (element.parentNode.classList.contains('seasonal-color')) {
			document.querySelector('.variation-name #selected-color').textContent = '';
			document.querySelector('#selected-seasonal-color').textContent = element.getAttribute('data-variant-option1');
		} else {
			document.querySelector('.variation-name #selected-color').textContent =
				element.getAttribute('data-variant-option1');
		}

		const newVariantId = element.dataset.variantId;
		const url = new URL(window.location.href);
		url.searchParams.set('variant', newVariantId);
		history.replaceState(null, '', url.toString());

		updatePDP(element);
	}

  function updateSectionDescription() {
    const sections = document.querySelectorAll('.product-description__section');
    sections.forEach((section) => {
      const sectionVariantId = section.getAttribute('data-variant-id');
      if (
        +sectionVariantId ===
        +document.querySelector('.product-section__variant-thumbnail.is-active').getAttribute('data-variant-id')
      ) {
        section.classList.remove('hide');
      } else {
        section.classList.add('hide');
      }
    });
  }

	function updatePDP(element) {
		let variantTitle = element.getAttribute('data-variant-title');
    updateSectionDescription();

		var isLensSelection = element.classList.contains('lens');

		function getActiveFrameColor() {
			var activeFrame = document.querySelector(
				'.product-section__variant-thumbnails.original-color .product-section__variant-thumbnail.is-active, .product-section__variant-thumbnails.seasonal-color .product-section__variant-thumbnail.is-active',
			);
			if (!activeFrame) return '';
			return (
				activeFrame.getAttribute('data-variant-option') ||
				activeFrame.getAttribute('data-variant-option1') ||
				''
			);
		}

		function getActiveLensColor() {
			var activeLens = document.querySelector(
				'.product-section__variant-thumbnails.lens-color .product-section__variant-thumbnail.lens.is-active',
			);
			if (!activeLens) return '';
			return activeLens.getAttribute('data-variant-option') || '';
		}

		function buildDisplayVariantTitle() {
			var frameColor = getActiveFrameColor();
			var lensColor = getActiveLensColor();

			if (isLensSelection) {
				lensColor = element.getAttribute('data-variant-option') || lensColor;
			} else {
				frameColor =
					element.getAttribute('data-variant-option') ||
					element.getAttribute('data-variant-option1') ||
					frameColor;
			}

			if (frameColor && lensColor) return frameColor + ' / ' + lensColor;
			if (frameColor) return frameColor;
			if (lensColor) return lensColor;
			return element.getAttribute('data-variant-title') || variantTitle || '';
		}

		function resolveFlowImage() {
			var visibleMedia = document.querySelector('li.product__media-item.grid__item.slider__slide:not([style*="display: none"]) img');
			if (visibleMedia) {
				var visibleSrc = visibleMedia.currentSrc || visibleMedia.getAttribute('src') || '';
				if (visibleSrc) return visibleSrc;
			}

			if (!isLensSelection) {
				var activeFrameSwatch = document.querySelector(
					'.product-section__variant-thumbnails.original-color .product-section__variant-thumbnail.is-active, .product-section__variant-thumbnails.seasonal-color .product-section__variant-thumbnail.is-active',
				);
				if (activeFrameSwatch) {
					var swatchRxImage = activeFrameSwatch.getAttribute('data-rx-image') || '';
					if (swatchRxImage) return swatchRxImage;
				}
			}

			var elementRxImage = element.getAttribute('data-rx-image') || '';
			if (elementRxImage) return elementRxImage;

			var flowRootNode = document.getElementById('wmp-prescription-flow');
			return flowRootNode ? (flowRootNode.getAttribute('data-product-image') || '') : '';
		}

		function syncFlowImage() {
			var flowRootNode = document.getElementById('wmp-prescription-flow');
			if (!flowRootNode) return;

			var src = resolveFlowImage();
			if (!src) return;

			flowRootNode.setAttribute('data-product-image', src);

			var sidebarImg = flowRootNode.querySelector('.wmp-flow__product-image img');
			if (sidebarImg) sidebarImg.setAttribute('src', src);

			var mobileThumb = flowRootNode.querySelector('.wmp-flow__mobile-thumb');
			if (mobileThumb) mobileThumb.setAttribute('src', src);

			var reviewMobileImage = document.querySelector('.wmp-review-mobile-product img');
			if (reviewMobileImage) reviewMobileImage.setAttribute('src', src);

			if (window.WmpStore && typeof window.WmpStore.get === 'function' && typeof window.WmpStore.set === 'function') {
				var p = window.WmpStore.get('product') || {};
				p.image = src;
				window.WmpStore.set('product', p);
			}
		}

		variantTitle = buildDisplayVariantTitle();

		const newVariantId = element.getAttribute('data-variant-id');
		const productType = element.getAttribute('data-product-type');
		const isAvailable = element.getAttribute('data-variant-available') === 'true';

		var flowRoot = document.getElementById('wmp-prescription-flow');
		if (flowRoot) {
			var priceValue = parseFloat(element.getAttribute('data-variant-price') || '0');
			var framePriceCents = isNaN(priceValue) ? 0 : Math.round(priceValue * 100);

			flowRoot.setAttribute('data-product-variant', variantTitle || '');
			flowRoot.setAttribute('data-product-variant-id', newVariantId || '');
			if (framePriceCents > 0) {
				flowRoot.setAttribute('data-product-price', String(framePriceCents));
			}

			if (window.WmpStore && typeof window.WmpStore.get === 'function' && typeof window.WmpStore.set === 'function') {
				var wmpProduct = window.WmpStore.get('product') || {};
				wmpProduct.variant = variantTitle || wmpProduct.variant || '';
				wmpProduct.variantId = newVariantId || wmpProduct.variantId || '';
				if (framePriceCents > 0) wmpProduct.price = framePriceCents;
				window.WmpStore.set('product', wmpProduct);

				var wmpPricing = window.WmpStore.get('pricing') || {};
				if (framePriceCents > 0) {
					wmpPricing.frame = framePriceCents;
					window.WmpStore.set('pricing', wmpPricing);
				}
			}

			var sidebarVariant = flowRoot.querySelector('.wmp-flow__product-variant');
			if (sidebarVariant) {
				sidebarVariant.textContent = variantTitle || '';
			}

			var mobileVariant = flowRoot.querySelector('.wmp-flow__mobile-product-variant');
			if (mobileVariant) {
				mobileVariant.textContent = variantTitle || '';
			}
		}

		updateFeaturesAccordion(newVariantId);
		document.querySelectorAll('.product .product-variant-id').forEach((element) => (element.value = newVariantId));
		let count = 0;

		document.querySelectorAll('li.product__media-item.grid__item.slider__slide').forEach((media) => {
			const seasonalColor = document.querySelectorAll('#selected-seasonal-color');
			const mediaTitle = media.getAttribute('data-variant-media-alt');

			if (mediaTitle === 'E-GIFT CARD') return;
			if (seasonalColor.length > 0) {
				if (mediaTitle && variantTitle === mediaTitle.split(' || ')[0]) {
					if (count === 0) {
						media.style.position = 'relative';
						media.querySelector('svg').style.display = 'block';
					}
					media.style.display = 'block';
					count++;
				} else {
					media.style.display = 'none';
				}
			} else {
				let oldVariant = document.querySelector(
					'.product-section__variant-thumbnails.original-color .product-section__variant-thumbnail.is-active.hide-color',
				);
				const newVariants = document.querySelectorAll(
					'.product-section__variant-thumbnails.original-color .product-section__variant-thumbnail',
				);
				const productMediaList = document.querySelectorAll('.product__media-list li');
				let lensColors = document.querySelector(
					'.product-section__variant-thumbnails.lens-color .product-section__variant-thumbnail.lens.is-active',
				);

				if (!oldVariant) {
					oldVariant = document.querySelector(
						'.product-section__variant-thumbnails.original-color .product-section__variant-thumbnail.is-active',
					);
				}

				newVariants.forEach((newVariant) => {
					if (
						!newVariant.classList.contains('hide-color') &&
						newVariant.dataset.variantOption === oldVariant.dataset.variantOption
					) {
						if (oldVariant.classList.contains('hide-color')) {
							newVariant.click();
						}

						if (!productMediaList.length > 0 || !lensColors) {
							lensColors = document.querySelector(
								'.product-section__variant-thumbnails .product-section__variant-thumbnail.is-active',
							);
						}

						productMediaList.forEach((newMedia) => {
							if (newMedia.dataset.variantMediaAlt) {
								const newMediaAlt = newMedia.dataset.variantMediaAlt.split(' || ')[0];
								if (newMediaAlt === lensColors.dataset.variantOption) {
									newMedia.style.display = 'block';
								} else {
									newMedia.style.display = 'none';
								}
							}
						});
					}
				});

			}
		});

		document.querySelectorAll('.product-media-modal__content .modal-image-wrapper').forEach((media) => {
			const mediaTitle = media.querySelector('img').getAttribute('alt').split(' || ')[0];

			if (mediaTitle && mediaTitle === variantTitle) {
				media.style.display = 'block';
			} else {
				media.style.display = 'none';
			}
		});

		document.querySelectorAll('.slider-circle-button').forEach((button) => {
			if (button.getAttribute('data-count') > count) {
				button.style.display = 'none';
			} else {
				button.style.display = 'block';
			}
		});

		syncFlowImage();
		if (typeof requestAnimationFrame === 'function') {
			requestAnimationFrame(function () {
				syncFlowImage();
				requestAnimationFrame(syncFlowImage);
			});
		}

		const sliderComponentPDP = document.querySelector('slider-component');
		if (sliderComponentPDP?.setSlidePosition) {
			sliderComponentPDP.setSlidePosition(0);
		}
		const parentBlock = document.querySelector('cart-drawer');
		if (!parentBlock) return;

		const buyButtons = document.querySelectorAll('.product .custom_button.add_to_cart');
		const soldoutButtons = document.querySelectorAll('.product .custom_button.sold_out');
		const selectLensesButton = document.querySelectorAll('.product .button_box .select-lenses');
		const generalButtonsWrapper = document.querySelectorAll('.product .button_box .general-buy-btns');

		if (productType?.toLowerCase().includes('prescription') && !isAvailable) {
			selectLensesButton.forEach((element) => element.classList.add('hide'));
			generalButtonsWrapper.forEach((element) => element.classList.remove('hide'));
			buyButtons.forEach((element) => element.classList.add('hide'));
			soldoutButtons.forEach((element) => element.classList.remove('hide'));
			soldoutButtons.forEach((element) => {
				element.querySelector('span').style.display = 'unset';
				element.querySelector('span').classList.remove('hide');
			});
		} else if (productType?.toLowerCase().includes('prescription') && isAvailable) {
			selectLensesButton.forEach((element) => element.classList.remove('hide'));
			generalButtonsWrapper.forEach((element) => element.classList.add('hide'));
			soldoutButtons.forEach((element) => {
				element.classList.add('hide');
			});
			buyButtons.forEach((element) => element.classList.add('hide'));
		} else if (!isAvailable) {
			buyButtons.forEach((element) => element.classList.add('hide'));
			soldoutButtons.forEach((element) => element.classList.remove('hide'));
			soldoutButtons.forEach((element) => {
				element.querySelector('span').style.display = 'unset';
				element.querySelector('span').classList.remove('hide');
			});
		} else {
			buyButtons.forEach((element) => element.classList.remove('hide'));
			soldoutButtons.forEach((element) => element.classList.add('hide'));
		}
	}

	function updateFeaturesAccordion(variantId) {
		const productInfo = document.querySelector('product-info');
		const destination = productInfo?.querySelector('.accordion__content.features');
		const template = productInfo?.querySelector(`[data-variant-features-template][data-variant-id="${variantId}"]`);

		if (destination && template) {
			destination.innerHTML = template.innerHTML;
		}
	}

	document.querySelectorAll('.product__accordion.accordion details summary').forEach((summary) => {
		summary.addEventListener('click', toggleAccordion);
	});

	function toggleAccordion(event) {
		event.preventDefault();

		document.querySelectorAll('.product__accordion details').forEach((el) => {
			if (el !== event.currentTarget.parentElement) {
				el.removeAttribute('open');
			}
		});

		event.currentTarget.parentElement.toggleAttribute('open');
	}

	const productSectionVariantThumbnail = document.querySelectorAll(
		'.product__info-wrapper .product-section__variant-thumbnails.original-color .product-section__variant-thumbnail',
	);
	const anotherOptions = document.querySelectorAll(
		'.product__info-wrapper .product-section__variant-thumbnails:not(.original-color) .product-section__variant-thumbnail',
	);
	const params = new URLSearchParams(window.location.search);
	const urlVariantId = params.get('variant');

	productSectionVariantThumbnail.forEach((variant) => {
		if (variant.dataset.variantId === urlVariantId) {
			anotherOptions.forEach((anotherOption) => {
				if (variant.dataset.variantTitle.includes(anotherOption.dataset.variantOption)) {
					anotherOption.click();
				}
			});
		}
	});

	const current_active_option = document.querySelector(
		'.product__info-wrapper .product-section__variant-thumbnails .product-section__variant-thumbnail.is-active',
	);
	if (current_active_option && current_active_option.parentNode.classList.contains('seasonal-color')) {
		document.querySelector('#selected-color').textContent = '';
	} else {
		const selectedSeasonalColor = document.querySelector('#selected-seasonal-color');
		if (selectedSeasonalColor) selectedSeasonalColor.textContent = '';
	}

	function getActiveFlowSourceElement() {
		return (
			document.querySelector(
				'.product-section__variant-thumbnails.original-color .product-section__variant-thumbnail.is-active, .product-section__variant-thumbnails.seasonal-color .product-section__variant-thumbnail.is-active',
			) ||
			document.querySelector('.product-section__variant-thumbnails .product-section__variant-thumbnail.is-active')
		);
	}

	function syncFlowFromActiveVariant() {
		var flowRoot = document.getElementById('wmp-prescription-flow');
		if (!flowRoot) return;

		var activeSource = getActiveFlowSourceElement();
		if (!activeSource) return;

		var frameActive = document.querySelector(
			'.product-section__variant-thumbnails.original-color .product-section__variant-thumbnail.is-active, .product-section__variant-thumbnails.seasonal-color .product-section__variant-thumbnail.is-active',
		);
		var lensActive = document.querySelector(
			'.product-section__variant-thumbnails.lens-color .product-section__variant-thumbnail.lens.is-active',
		);

		var frameLabel = frameActive
			? (frameActive.getAttribute('data-variant-option') || frameActive.getAttribute('data-variant-option1') || '')
			: '';
		var lensLabel = lensActive ? (lensActive.getAttribute('data-variant-option') || '') : '';
		var displayVariant = frameLabel && lensLabel
			? frameLabel + ' / ' + lensLabel
			: (frameLabel || lensLabel || activeSource.getAttribute('data-variant-title') || '');

		if (displayVariant) {
			flowRoot.setAttribute('data-product-variant', displayVariant);
			var flowVariant = flowRoot.querySelector('.wmp-flow__product-variant');
			if (flowVariant) flowVariant.textContent = displayVariant;
			var mobileVariant = flowRoot.querySelector('.wmp-flow__mobile-product-variant');
			if (mobileVariant) mobileVariant.textContent = displayVariant;
		}

		var variantId = activeSource.getAttribute('data-variant-id') || '';
		if (variantId) flowRoot.setAttribute('data-product-variant-id', variantId);

		var priceValue = parseFloat(activeSource.getAttribute('data-variant-price') || '0');
		if (!isNaN(priceValue) && priceValue > 0) {
			flowRoot.setAttribute('data-product-price', String(Math.round(priceValue * 100)));
		}

		var visibleMedia = document.querySelector('li.product__media-item.grid__item.slider__slide:not([style*="display: none"]) img');
		var imageSrc = visibleMedia ? (visibleMedia.currentSrc || visibleMedia.getAttribute('src') || '') : '';
		if (!imageSrc && frameActive) imageSrc = frameActive.getAttribute('data-rx-image') || '';
		if (!imageSrc) imageSrc = flowRoot.getAttribute('data-product-image') || '';

		if (imageSrc) {
			flowRoot.setAttribute('data-product-image', imageSrc);
			var flowImage = flowRoot.querySelector('.wmp-flow__product-image img');
			if (flowImage) flowImage.setAttribute('src', imageSrc);
			var mobileThumb = flowRoot.querySelector('.wmp-flow__mobile-thumb');
			if (mobileThumb) mobileThumb.setAttribute('src', imageSrc);
		}

		if (window.WmpStore && typeof window.WmpStore.get === 'function' && typeof window.WmpStore.set === 'function') {
			var product = window.WmpStore.get('product') || {};
			if (displayVariant) product.variant = displayVariant;
			if (variantId) product.variantId = variantId;
			if (imageSrc) product.image = imageSrc;
			if (!isNaN(priceValue) && priceValue > 0) product.price = Math.round(priceValue * 100);
			window.WmpStore.set('product', product);
		}
	}

	// Keep first open in sync without triggering full PDP side effects.
	syncFlowFromActiveVariant();

	document.querySelectorAll('[data-wmp-open]').forEach((trigger) => {
		trigger.addEventListener('click', function () {
			syncFlowFromActiveVariant();
			if (typeof requestAnimationFrame === 'function') {
				requestAnimationFrame(syncFlowFromActiveVariant);
			}
		});
	});
});

fetch('/browsing_context_suggestions.json')
	.then((res) => res.json())
	.then((data) => {
		const country = data.detected_values.country.handle?.toLowerCase();
		// shipping text
		const domestic = document.querySelector('.shipping_text');
		const international = document.querySelector('.shipping_text_international');

		// tooltips
		const tooltip = document.querySelector('.tooltiptext.tooltip');
		const tooltipInternational = document.querySelector('.tooltiptext.tooltip_international');

		// free returns
		const freeReturns = document.querySelector('.free_returns');
		const freeReturnsInternational = document.querySelector('.free_returns_international');

		if (country === 'us') {
			// shipping text
			domestic.classList.remove('hidden');
			international.classList.add('hidden');

			// tooltip
			tooltip.classList.remove('hidden');
			tooltipInternational.classList.add('hidden');

			// free returns
			freeReturns.classList.remove('hidden');
			freeReturnsInternational.classList.add('hidden');
		} else {
			// shipping text
			domestic.classList.add('hidden');
			international.classList.remove('hidden');

			// tooltip
			tooltip?.classList.add('hidden');
			tooltipInternational?.classList.remove('hidden');

			// free returns
			freeReturns.classList.add('hidden');
			freeReturnsInternational.classList.remove('hidden');
		}
	})
	.catch((error) => {
		console.error('Error fetching country info:', error);
	});

document.addEventListener('DOMContentLoaded', () => {
	const originalItem = document.querySelector('.product-section__variant-thumbnails.original-color');
	const lensItems = document.querySelector('.product-section__variant-thumbnails.lens-color');

	if (originalItem && lensItems) {
		function onUrlChange(callback) {
			let oldHref = location.href;

			window.addEventListener('popstate', () => {
				if (location.href !== oldHref) {
					callback(location.href);
					oldHref = location.href;
				}
			});

			['pushState', 'replaceState'].forEach((method) => {
				const original = history[method];
				history[method] = function (...args) {
					original.apply(this, args);
					if (location.href !== oldHref) {
						callback(location.href);
						oldHref = location.href;
					}
				};
			});
		}

		originalItem.addEventListener('click', (evt) => {
			readProduct();
		});

		onUrlChange((newUrl) => readProduct(newUrl));

		function readProduct(newUrl) {
			const params = new URLSearchParams(window.location.search);
			const currentVariantId = +params.get('variant');
			const product = JSON.parse(document.getElementById('product-data').textContent);

			if (!product) return;

			if (currentVariantId === 0) {
				const url = new URL(window.location);
				url.searchParams.set('variant', `${product.variants[0].id}`);
				window.history.replaceState({}, '', url);

				setTimeout(() => {
					readProduct();
				}, 0);
			}

			const variants = product.variants;
			const currentVariant = variants.find((variant) => variant.id === currentVariantId);

			const originColors = document.querySelectorAll(
				'.product__info-wrapper .product-section__variant-thumbnails.original-color .product-section__variant-thumbnail',
			);
			const lensColor = document.querySelector(
				'.product__info-wrapper .product-section__variant-thumbnails.lens-color',
			);
			const productMedias = document.querySelectorAll(
				'.product media-gallery .product__media-list .product__media-item',
			);
			const zoomProductMedias = document.querySelectorAll('.product-media-modal__content .modal-image-wrapper');
			const descriptions = document.querySelectorAll('.product-description__section');

			setTimeout(() => {
				originColors.forEach((color) => color.classList.add('hide-color'));
				productMedias.forEach((media) => (media.style.display = 'none'));
				zoomProductMedias.forEach((media) => (media.style.display = 'none'));

				const activeOriginColors = Array.from(originColors).filter((color) => {
					const lensOption = color.dataset.variantTitle.split(' / ')[1];
					return lensOption.includes(currentVariant.options[1]);
				});

				activeOriginColors.forEach((color) => color.classList.remove('hide-color'));

				productMedias.forEach((media, index) => {
					const variantTitle = media.dataset.variantMediaAlt.split(' || ')[0];
					if (variantTitle === `${currentVariant.options[0]} / ${currentVariant.options[1]}`) {
						media.style.display = 'block';
					}
				});

				zoomProductMedias.forEach((media) => {
					const mediaImage = media.querySelector('img');
					const mediaAlt = mediaImage.getAttribute('alt').split(' || ')[0];

					if (currentVariant.title === mediaAlt) {
						media.style.display = 'block';
					}
				});
				hiddenDuplicateEl();

				changeSectionDescription();
			}, 0);

			function changeSectionDescription() {
				if (descriptions.length > 0) {
					descriptions.forEach((item) => item.classList.add('hide'));
					const currentDescription = Array.from(descriptions).find(
						(item) => +item.dataset.variantId === currentVariant.id,
					);
					currentDescription.classList.remove('hide');
				}
			}
		}

		readProduct();
	}
});
function hiddenDuplicateEl() {
	setTimeout(() => {
		const originColorsEL = document.querySelectorAll(
			'.product__info-wrapper .original-color .product-section__variant-thumbnail',
		);
		const lensColor = document.querySelectorAll(
			'.product__info-wrapper .lens-color .product-section__variant-thumbnail',
		);

		const originalNoHiddenEl =
			lensColor.length > 0
				? Array.from(originColorsEL).filter((option) => !option.classList.contains('hide-color'))
				: Array.from(originColorsEL).filter((option) => option);

		const groupedDuplicates = originalNoHiddenEl.reduce((acc, el) => {
			const key = el.dataset.variantOption;
			if (!key) return acc;
			if (!acc[key]) acc[key] = [];
			acc[key].push(el);
			return acc;
		}, {});

		const duplicateGroups = Object.values(groupedDuplicates).filter((group) => group.length > 1);

		duplicateGroups.forEach((group) => {
			if (group.length > 1) {
				const activeIndex = group.findIndex((el) => el.classList.contains('is-active'));

				group.forEach((el, index) => {
					if (activeIndex !== -1) {
						if (index === activeIndex) {
							el.classList.remove('custom-hide-color', 'hide-color');
						} else {
							el.classList.add('hide-color', 'custom-hide-color');
						}
					} else {
						if (index >= 1) {
							el.classList.add('hide-color', 'custom-hide-color');
						} else {
							el.classList.remove('hide-color', 'custom-hide-color');
						}
					}
				});
			}
		});

		if (typeof window.syncVariantThumbnailRadioState === 'function') {
			window.syncVariantThumbnailRadioState();
		}
	});
}
hiddenDuplicateEl();

class insertSizesOptions {
	constructor() {
		this.productPage = document.querySelector('body[data-template="product"]');
		if (!this.productPage) return;

		this.product = JSON.parse(document.getElementById('product-data').textContent);
		this.options = document.querySelectorAll('.product__info-wrapper .product-section__variant-thumbnail');
		this.originalColors = document.querySelectorAll('.original-color .product-section__variant-thumbnail');
		this.lensColor = document.querySelectorAll('.lens-color .product-section__variant-thumbnail');
		this.sizesElement = document.querySelector('.product .no-color-wrapper');
		if (!this.sizesElement) return;
		this.sizes = this.sizesElement.querySelectorAll('.product-section__variant-thumbnail');
		this.btnSoldOut = document.querySelector('.product .custom_button.sold_out');
		this.btnAddToCart = document.querySelector('.product .custom_button.add_to_cart');
		this.variantId = this.readUrl();
		this.currentVariant = this.product.variants.find((variant) => variant.id === this.variantId);

		this.init();
	}

	init() {
		const enable = this.sizesInLocatedOnPage();

		if (enable) {
			this.changeOptions();

			if (this.sizes.length > 0) {
				this.changeSizes();
			}
		}
	}

	sizesInLocatedOnPage() {
		return !!this.sizesElement;
	}

	readUrl() {
		const url = new URL(window.location.href);
		const params = new URLSearchParams(url.search);
		const variantID = params.get('variant');

		if (variantID) return +variantID;
		else return this.product.variants[0].id;
	}

	changeOptions() {
		this.options.forEach((option) => {
			option.addEventListener('click', () => {
				this.activeVariantTitle(option.dataset.variantOption, option);
				this.enableOriginalColors(option.dataset.variantOption);
				hiddenDuplicateEl();

				const loadUpdateDescriptionGlobal = setInterval(() => {
					if (window.updateDescriptionGlobal) {
						window.updateDescriptionGlobal();

						clearInterval(loadUpdateDescriptionGlobal);
					}
				});

				setTimeout(() => {
					clearInterval(loadUpdateDescriptionGlobal);
				}, 5000);
			});
		});

		const activeColor = document.querySelector('.original-color .is-active');
		activeColor.click();
	}

	enableOriginalColors(title) {
		const parent = document.querySelector('.product-section__variant-thumbnails.original-color');
		this.originalColors.forEach((color) => {
			color.classList.remove('is-active');

			if (color.dataset.variantTitle.replace('``', '"') === title) {
				color.classList.add('is-active');
			}
		});

		if (this.lensColor.length <= 0) {
			this.originalColors.forEach((color) => {
				color.classList.remove('hide-color');
			});
		}
		setTimeout(() => {
			parent.style.opacity = 1;
			if (typeof window.syncVariantThumbnailRadioState === 'function') {
				window.syncVariantThumbnailRadioState(parent);
			}
		}, 20)
	}

	changeSizes() {
		this.sizes.forEach((size) => {
			size.addEventListener('click', () => {
				this.sizes.forEach((el) => el.classList.remove('is-active'));
				size.classList.add('is-active');
			});
		});
	}

	activeVariantTitle(clickedOption, option) {
		const priceBox = document.querySelector('.product__main-info-wrapper .price.price--large');
		const galleryParent = document.querySelector('media-gallery');


		setTimeout(() => {
			const activeSize = document.querySelectorAll(
				'.no-color-wrapper .product-section__variant-thumbnail.no-color.is-active',
			);

			const activeTitle = [];

			if (!option.classList.contains('no-color')) {
				activeTitle.push(clickedOption);
				activeSize.forEach((item) => activeTitle.push(item.dataset.variantOption));
			}

			if (this.currentVariant) {
				let selectedOptions = [...this.currentVariant.options];

				const optionIndex = this.currentVariant.options.findIndex((opt, idx) => {
					return this.product.variants.some((variant) => variant.options[idx] === clickedOption.replace('``', '"'));
				});

				if (optionIndex === 0) {
					selectedOptions = option.dataset.variantTitle.split(' / ');
				} else {
					selectedOptions.splice(optionIndex, 1, clickedOption);
				}

				const matchingVariants = this.product.variants.filter((variant) => {
					return variant.options[optionIndex] === clickedOption.replace('``', '"');
				});

				const titleArray = activeTitle.length > 0 ? activeTitle.join(' / ') : selectedOptions.join(' / ');

				if (matchingVariants.length) {
					this.currentVariant = this.product.variants.find(
						(variant) => variant.title === titleArray.replace('``', '"'),
					);

					if (this.currentVariant) {
						this.findCurrentVariant(this.currentVariant.title);
						this.enableOriginalColors(this.currentVariant.title);
						this.selectRightSize(this.currentVariant.title);
					}

					const salePrice = priceBox.querySelector('.price__sale .price-item--sale');
					const priceRegular = priceBox.querySelectorAll('.price-item--regular');

					const currency = window.Shopify?.currency?.active || 'USD';

					const price = this.currentVariant.price / 100;
					const compare_at_price = this.currentVariant.compare_at_price / 100;

					const formattedPrice = new Intl.NumberFormat('en', {
						style: 'currency',
						currency,
						minimumFractionDigits: 0,
						maximumFractionDigits: 2,
					}).format(price);

					const formattedCompareAtPrice = new Intl.NumberFormat('en', {
						style: 'currency',
						currency,
						minimumFractionDigits: 0,
						maximumFractionDigits: 2,
					}).format(compare_at_price);

					salePrice.textContent = formattedPrice;

					priceRegular.forEach((box) => {
						if(compare_at_price) {
							box.textContent = formattedCompareAtPrice;
						} else {
							box.textContent = formattedPrice;
						}
					});

					if (price < compare_at_price) priceBox.classList.add('price--on-sale');
					else priceBox.classList.remove('price--on-sale');

					this.findNoAvailableOptions(matchingVariants, clickedOption);

					setTimeout(() => {
						galleryParent.style.opacity = 1;
					}, 0);
				}
			}
		}, 0);
	}

	findNoAvailableOptions(availableVariants) {
		const availableOptions1 = availableVariants.filter((v) => v && v.option1).map((v) => v.option1);

		const uniqueOptions1 = [...new Set(availableOptions1)];

		this.originalColors.forEach((color) => {
			color.classList.add('color-non-available');
			if (uniqueOptions1.includes(color.dataset.variantOption)) {
				color.classList.remove('color-non-available');
			}
		});
	}

	selectRightSize(title) {
		const titleArray = title.split(' / ');

		this.sizes.forEach((size) => size.classList.remove('is-active'));
		const rightSize = Array.from(this.sizes).find((size) =>
			titleArray.includes(size.dataset.variantOption.replace('``', '"')),
		);

		rightSize.classList.add('is-active');
		if (typeof window.syncVariantThumbnailRadioState === 'function') {
			window.syncVariantThumbnailRadioState(this.sizesElement);
		}
	}

	findCurrentVariant(title) {
		const currentVariant = this.product.variants.find((variant) => variant.title === title);
		if (!currentVariant) return;

		this.variantId = currentVariant.id;
		this.currentVariant = currentVariant;

		this.changeUrl();


		setTimeout(() => {
			this.showSize();
			this.changeTypeButtons();
			this.insertCurrentID();
			this.changeGallery();
		}, 20);

		this.changeBadge();
	}


	changeBadge() {
		const badges = document.querySelectorAll('.slider-mobile-gutter .variant-badges');
		badges.forEach((badge) => {
			badge.classList.add('hidden-badge');
			const badgeId = badge.getAttribute('data-badges-variant');
			if (+badgeId === this.variantId) {
				badge.classList.remove('hidden-badge');
			}
		});

		const polarizedBadges = document.querySelectorAll('.slider-mobile-gutter .polarized-badge');
		polarizedBadges.forEach((badge) => {
			badge.classList.add('hidden-badge');
			const badgeId = badge.getAttribute('data-polarized-variant');
			if (+badgeId === this.variantId) {
				badge.classList.remove('hidden-badge');
			}
		});
	}

	insertCurrentID() {
		const variantIDEl = document.querySelector('.product input[name="id"]');
		variantIDEl.value = this.currentVariant.id;
	}

	changeTypeButtons() {
		setTimeout(() => {
			if (this.currentVariant.available) {
				this.btnAddToCart.classList.remove('hide');
				this.btnSoldOut.classList.add('hide');
			} else {
				this.btnAddToCart.classList.add('hide');
				this.btnSoldOut.classList.remove('hide');
			}
		});
	}

	changeUrl() {
		const url = new URL(window.location.href);
		const params = new URLSearchParams(url.search);
		params.set('variant', this.variantId);
		url.search = params.toString();
		window.history.replaceState({}, '', url.toString());
	}

	showSize() {
    const sizeItems = this.sizesElement.querySelectorAll('.product-section__variant-thumbnail');
		if (this.lensColor.length > 0) {
			const availableVariants = this.product.variants.filter(
				(variant) => variant.option1 === this.currentVariant.option1 && variant.option2 === this.currentVariant.option2,
			);

			if (availableVariants.length <= 1 && sizeItems.length) this.sizesElement.classList.add('hide');
      else this.sizesElement.classList.remove('hide');
		} else {
			const availableVariants = this.product.variants.filter(
				(variant) => variant.option1 === this.currentVariant.option1,
			);

			if (availableVariants.length < 1 && sizeItems.length > 1) this.sizesElement.classList.add('hide');
      else this.sizesElement.classList.remove('hide');
		}
	}

	changeGallery = () => {
		const show_hide_images = (item) => {
			const img = item.querySelector('.product__media img') || item.querySelector('img');

			const loadElems = setInterval(() => {
				if (img && this.currentVariant.title) {
					const altTitle = img.alt.split(/\s*\|\|\s*/)[0];
					if (altTitle === this.currentVariant.title) {
						item.style.display = 'block';
						item.style.opacity = 1;
					} else {
						item.style.display = 'none';
					}

					clearInterval(loadElems);
				}
			});

			setTimeout(() => {
				clearInterval(loadElems);
			}, 10000);
		};

		setTimeout(() => {
			const galleryItems = document.querySelectorAll('.product__media-list.contains-media .product__media-item');
			const zoomGallery = document.querySelectorAll('.product-media-modal__content .modal-image-wrapper');

			if (galleryItems.length > 0) {
				galleryItems.forEach((item) => show_hide_images(item));
			}

			if (zoomGallery.length > 0) {
				zoomGallery.forEach((item) => show_hide_images(item));
			}
		}, 20);
	};
}
new insertSizesOptions();

setTimeout(() => loadDots(), 0);

const loadDots = () => {
	setTimeout(() => {
		const dots = document.querySelectorAll('.slider-circle-button');
		const images = document.querySelectorAll('.product__media-list .product__media-item');
		const images_showed = Array.from(images).filter((image) => image.style.display === 'block');
		if (dots.length > 0) {
			images_showed.forEach((item, index) => {
				if (dots[index]) {
					dots[index].style.display = 'block';
				}
			});
		}
	}, 0);
};

function handleUrlChange() {
	loadDots();
}

window.addEventListener('popstate', handleUrlChange);

window.addEventListener('hashchange', handleUrlChange);

(function (history) {
	const pushState = history.pushState;
	const replaceState = history.replaceState;

	history.pushState = function (...args) {
		const result = pushState.apply(this, args);
		handleUrlChange();
		return result;
	};

	history.replaceState = function (...args) {
		const result = replaceState.apply(this, args);
		handleUrlChange();
		return result;
	};
})(window.history);
